import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './visibleTo.html';
import './visibleTo.scss';

export interface CommentVisibleToVMCofig {
    items: SubscribableOrNullableValue<Array<any>>
    isLoading: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class CommentVisibleToVM {
    label = `${labels.VisibleTo}:`

    items: Subscribable<Array<any>>
    isLoading: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentVisibleToVMCofig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.items = ko.flattenComputed(config.items, []);
        this.isLoading = ko.flattenComputed(config.isLoading, false);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic__comment__visible-to': true
            }
        }, this);
    }
}